import { useMemo } from "react";
import {
  InputType,
  ResponseFormElementsType,
} from "../types/forms/FormFieldsStrategy.type";
import ManualQuoteResElement from "@/components/Quotes/ManualQuoteResponse/ManualQuoteResElement";
import Input from "antd/es/input/Input";
import { Select } from "antd";
import { cn } from "../utils";

export default function useGenerateResponseElements(
  strategy: ResponseFormElementsType[]
) {
  const pickElement = (
    type: InputType,
    variant: Partial<ResponseFormElementsType>
  ) => {
    switch (type) {
      case "text":
        return (
          <Input
            className={cn(
              "bg-primaryDim px-4 py-3 !disabled:text-black h-10 text-black font-kanit font-light",
              variant.inputClassElement
            )}
            readOnly={variant.readonly}
            disabled={variant.readonly}
          />
        );
      case "select":
        return (
          <Select
            disabled={variant.readonly}
            removeIcon={variant.readonly}
            rootClassName="!w-full"
            popupClassName="max-w-fit min-w-[290px]"
            className={cn(
              "custom-select-antd text-base border h-[40px] font-kanit font-light !border-none rounded-lg ",
              variant.selectClassElement
            )}
            options={variant.options}
            variant="filled"
            style={{
              backgroundColor: "#FFFFFF",
            }}
          />
        );
      default:
        return null;
    }
  };
  return useMemo(() => {
    return strategy.map((el) => {
      return (
        <ManualQuoteResElement
          key={el.attribute}
          attributeName={el.attribute}
          value={el.initialValue}
          required={el.required}
          valueForLabel={
            el.options
              ? el.options.find(
                  (opt) =>
                    opt.value.toString() === el?.valueForLabel?.toString()
                )?.label
              : el.valueForLabel
          }
          pattern={el.pattern}
          patternMessage={el.patternMessage}
        >
          {pickElement(el.type, el)}
        </ManualQuoteResElement>
      );
    });
  }, [strategy]);
}
